export default __webpack_public_path__ + "static/media/background-intro-mobile.56f587b5.png";